import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import s from './s.module.css'
import { lang } from './lang'

interface Props {
  onClick: () => void
}

export default function ShowAllButton({ onClick }: Props) {
  return (
    <Button className={s.button} type="link" onClick={onClick}>
      <Text color="var(--accent-light)">
        <FormattedMessage {...lang.showAll} />
      </Text>
    </Button>
  )
}
